const events = {};

const create = (name) => {
  const event = document.createEvent('Event');
  event.initEvent(name, true, true);
  return event;
}

const dispatch = (name, el) => {
  el = el || document;
  el.dispatchEvent(name);
}

export const registerEvent = (name) => {
  if (!events[name]) {
    events[name] =  create(name);
  }
  return true;
};

export const dispatchEvent = (name, el) => {
  if (!events[name]) {
    return false;
  }
  dispatch(events[name], el)
  return true;
};

export const dispatchCustomEventDetail = (name, detail) => {
  const event = new CustomEvent(name, { detail });
  document.dispatchEvent(event);
}
